import { createSelector } from 'reselect';

// Config
import { getClearpayServiceUnavailableSelector, getSelectedPaymentTypeSelector } from '../../redux/reducers/payment/paymentSelector';

const clearpayConnectMessageState = createSelector(
  [
    getSelectedPaymentTypeSelector,
    getClearpayServiceUnavailableSelector,
  ],
  (selectedPaymentType, clearpayServiceUnavailable) => ({
    showMessage: selectedPaymentType === undefined && clearpayServiceUnavailable,
  }),
);

export default clearpayConnectMessageState;
